// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__b4u_I","choiceBoxes":"toolbarselects_choiceBoxes__3teN1","simpleField":"toolbarselects_simpleField__1tYD8"};